const projectsReducerDefaultState = [];

export default (state = projectsReducerDefaultState, action) => {
  switch (action.type) {
    case 'SET_PROJECTS':
      return action.projects;
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/projects.js